import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames/bind';

import { Icon } from 'sheets';
import scrollableTo from 'components/ScrollableTo/ScrollableTo';
import ScrollCTA from 'components/ScrollCTA/ScrollCTA';

import styles from './IconProps.css';

const cx = classNames.bind(styles);

const IconProps = (props) => {
  const renderIcons = () => {
    return props.iconProps.map((prop, i) => {
      return (
        <figure
          className={cx(`prop-container`, `prop-container--${prop.icon}`)}
          key={i}
        >
          <Icon
            className={styles[`prop-icon`]}
            name={prop.icon}
          />
          <figcaption
            className={styles[`prop-caption`]}
            dangerouslySetInnerHTML={{__html: prop.caption}} />
        </figure>
      );
    });
  };

  return (
    <div className={styles.container}>
      <ScrollCTA scrollToId="iconProps" />
      <div className={styles[`props`]}>
        {renderIcons()}
      </div>
    </div>
  );
};

IconProps.propTypes = {
  iconProps: PropTypes.array.isRequired,
};

export default scrollableTo(IconProps);
